@use "~@optimizely/design-tokens/dist/scss/colors";

:host {
  display: block;
  height: 40px;
  font-size: 14px;
  position: relative;
  z-index: 99999;
}

.logo {
  display: flex;
  align-items: center;
  color: #fff;
  margin-right: var(--axiom-space-xlarge);
}

.logo img {
  height: 30px;
}

.logo::before {
  background-color: #0037ff;
  content: '';
  display: block;
  height: 40px;
  left: 0;
  position: absolute;
  width: 18px;
}

.logo > span {
  margin-left: 8px;
}

img {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  z-index: 1;
}

.container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  padding: 0 24px 0 8px;
  background-color: #080736;
  box-sizing: border-box;
  color: white;
}

/* Slightly more opaque background for browsers that don't support blur */
.container--light {
  background: linear-gradient(
    161.26deg,
    rgba(255, 255, 255, 0.68) 7.94%,
    rgba(255, 255, 255, 0.58) 92.19%
  );
  color: #080736;
}

/* Blur for browsers that support it */
@supports (
  (-webkit-backdrop-filter: blur(40px)) or (backdrop-filter: blur(40px))
) {
  .container--light {
    background: linear-gradient(
      161.26deg,
      rgba(255, 255, 255, 0.46) 7.94%,
      rgba(255, 255, 255, 0.36) 92.19%
    );
    backdrop-filter: blur(40px);
  }
}

.container--light > .logo {
  color: #080736;
}

.container--light > .logo::before {
  display: none;
}

.container--sticky {
  position: fixed;
  top: 0;
  z-index: 999999;
}

.right-menu {
  display: flex;
  align-items: center;
}

.component-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: stretch;
}

.system-components {
  display: flex;
  align-items: center;
  & > *:not([style*="diplay:none"]) {
    width: var(--global-nav-icon-size);
    height: var(--global-nav-icon-size);
    &:hover {
      background-color: colors.$brand-blue-base;
      color: colors.$tile-hover-text-title-color;
    }
    &:active, &:focus-within {
      background-color: colors.$brand-blue-extra-light;
      color: colors.$tile-hover-text-title-color;
    }
  }
  ::slotted([slot="system-component"]) {
    color: #fff;
  }
}

.name {
  display: flex;
  align-items: center;
  padding-left: var(--axiom-space-small)
}
